export default function startVideoForSelectedItem({ commit }, { params }) {
  commit("START_VIDEO", params);
}
